import {
  LoginWithGoogleResponseDTO,
  LoginWithGoogleResponseDTOFailed,
  LoginWithGoogleResponseDTOSuccessLogin,
  LoginWithGoogleResponseDTOSuccessRegister,
} from "../models";

export const isError = (
  response: LoginWithGoogleResponseDTO,
): response is LoginWithGoogleResponseDTOFailed => {
  return (
    LoginWithGoogleResponseDTOFailed.safeParse(response).success &&
    (response?.statusReg?.length || 0) > 0
  );
};

export const isSuccessLogin = (
  response: LoginWithGoogleResponseDTO,
): response is LoginWithGoogleResponseDTOSuccessLogin => {
  return LoginWithGoogleResponseDTOSuccessLogin.safeParse(response).success;
};

export const isSuccessRegister = (
  response: LoginWithGoogleResponseDTO,
): response is LoginWithGoogleResponseDTOSuccessRegister => {
  return LoginWithGoogleResponseDTOSuccessRegister.safeParse(response).success;
};
